import { Component, inject } from "@angular/core";
import { RouterLink } from "@angular/router";

import { HamburgerMenuComponent } from "../hamburger-menu/hamburger-menu.component";
import { ApiService } from "src/app/api.service";

@Component({
	selector: "app-header",
	templateUrl: "./header.component.html",
	styleUrls: ["./header.component.scss"],
	imports: [RouterLink, HamburgerMenuComponent]
})
export class HeaderComponent {
	api = inject(ApiService);

}
